import SalesOrderList from '../components/SalesOrderList';

function SalesOrderPage() {
  return (
    <SalesOrderList 
      isAdmin={true}
    />
  );
}

export default SalesOrderPage;
